module.exports = __webpack_public_path__ + "img/14.fe7b2641.png";